import {
  SentimentAnalysisDataEntry,
  useSentimentAnalysisChart,
} from "@jugl-web/domain-resources/analytics/components/SentimentAnalysisWidget";
import { WidgetEmptyStateLabel } from "@jugl-web/domain-resources/analytics/components/WidgetEmptyStateLabel";
import { useTranslations } from "@jugl-web/utils";
import Highcharts from "highcharts";
import "highcharts/modules/sankey";
import HighchartsReact from "highcharts-react-official";
import { FC } from "react";
import { ReactComponent as QuestionIcon } from "./assets/question.svg";
import { WidgetContainer } from "../WidgetContainer";
import { WidgetContainerTitle } from "../WidgetContainerTitle";

export const SentimentAnalysisWidget: FC<{
  data: SentimentAnalysisDataEntry[];
}> = ({ data }) => {
  const { t } = useTranslations();
  const { chartRef, options, isEmpty } = useSentimentAnalysisChart(data);

  return (
    <WidgetContainer className="flex h-[660px] flex-col items-stretch gap-8">
      <WidgetContainerTitle
        icon={<QuestionIcon className="shrink-0" />}
        title={t({
          id: "cx-page.sentiment-analysis",
          defaultMessage: "Sentiment analysis",
        })}
      />
      {!isEmpty ? (
        <div className="min-h-0 w-full flex-1">
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            containerProps={{
              className: "h-full w-full",
            }}
            options={options}
          />
        </div>
      ) : (
        <div className="flex h-full items-center justify-center">
          <WidgetEmptyStateLabel />
        </div>
      )}
    </WidgetContainer>
  );
};
